import { connect, mapProps } from '@formily/react';
import { CnEmployeeSelect as UiEmployeeSelect, } from '@/components/cn-employee-select';
import { mapSize, mapStatus } from '@/form/__builtins__';
export const CnEmployeeSelect = connect(UiEmployeeSelect, mapProps(mapSize, mapStatus));
CnEmployeeSelect.displayName = 'CnEmployeeSelect';
